import { render, staticRenderFns } from "./OurServiceBank.vue?vue&type=template&id=7178ba2d&scoped=true"
import script from "./OurServiceBank.vue?vue&type=script&lang=js"
export * from "./OurServiceBank.vue?vue&type=script&lang=js"
import style0 from "./OurServiceBank.vue?vue&type=style&index=0&id=7178ba2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7178ba2d",
  null
  
)

export default component.exports